import Checkbox from '../../components/form/Checkbox';

const OptionsList = ({ list, title, onChange, selectedIds, ...props }) => {
  return (
    <div {...props}>
      {list.length !== 0 && (
        <p className="label-large mb-5 text-start">{title}</p>
      )}
      <div className="flex flex-col gap-3">
        {list
          .filter(({ hideByType }) => !hideByType)
          .slice(0, 12)
          .map((item, index) => (
            <Checkbox
              key={index}
              label={item.name || item.value}
              checked={selectedIds.includes(item.id)}
              onChange={() => onChange(item.id)}
            />
          ))}
      </div>
    </div>
  );
};

export default OptionsList;
